<template>
	<div class="forgot-password">
		<!-- PASSWORD RESET -->
		<div class="container">
			<h3>{{ $t("profileForgot.header") }}</h3>
			<p>{{ $t("profileForgot.enterEmail") }}</p>
			<form v-if="!token" @submit.prevent="submit" class="form-inline mt-30">
        <form-error :errors='errors' :attribute="'errors'">
  				<div class="form-group">
  					<div class="input-group">
  						<input v-model='email' class="form-control" style="width:350px" :placeholder="$t('profileForgot.email')">
  					</div>
  				</div>
        </form-error>
				<button type="submit" class="btn btn-primary" style="vertical-align: top;">{{ $t("profileForgot.sendReset") }}</button>
			</form>

      <form v-else @submit.prevent="resetPassword" class="form mt-30 col-md-6">
        <label>{{ $t('profile.newPassword') }}</label>
        <div class="form-group">
          <input v-model='user.password' type="password" class="form-control" :placeholder="$t('profile.password')">
        </div>
        <label>{{ $t('profile.confirmPassword') }}</label>
        <div class="form-group">
          <input v-model='user.repeat_password' type="password" class="form-control" :placeholder="$t('profile.confirmPassword')">
        </div>
        <button type="submit" class="btn btn-primary pull-right" style="vertical-align: top;">{{ $t('submit') }}</button>
      </form>

      <alert :success="success" :error="error" class="col-md-12 mt-20"></alert>

		</div><!-- .container -->

    <crowd-or-rais></crowd-or-rais>
  </div>
</template>

<script>
// API
import auth from '@/api/v1/auth/authService';
// Components
import Alert from '@/components/Alert';
import FormError from '@/components/FormError';
import CrowdOrRais from '@/components/CrowdOrRais';

export default {
  components: { Alert, FormError, CrowdOrRais },
  data() {
    return {
      email: '',
      success: '',
      error: '',
      errors: {},
      user: {},
    };
  },
  methods: {
    clearAlerts() {
      this.success = '';
      this.errors = {};
    },
    submit() {
      this.clearAlerts();
      auth.forgotPassword(this.email).then(() => {
        this.success = 'Instrukcja zmiany hasła została wysłana na podany adres';
      }).catch((response) => {
        this.errors = response.response.data;
      });
    },
    resetPassword() {
      this.clearAlerts();
      const data = {
        token: this.token,
        user: this.user,
      };
      if (this.user.password === this.user.repeat_password) {
        auth.resetPassword(data).then(() => {
          this.success = 'Hasło zostało zmienione';
        }).catch((response) => {
          this.error = response.response.data.errors[0];
        });
      } else {
        this.error = 'Hasła muszą być identyczne';
      }
    },
  },
  computed: {
    token() {
      return this.$route.query.token;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?9a1b0e14